import Mixin from './mixin';

export default Mixin;